module.exports = __webpack_public_path__ + "static/media/5scarrental.fb98e9c1.svg";